import type { Layout } from 'types';

export const applyLayoutStatus = (layouts: Layout[], status: boolean): Layout[] =>
  layouts.map((layout: Layout) => ({ ...layout, active: status }));
